var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChieldCheckFill(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 33",
    fill: "#000",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5251 8.15336L17.5755 5.17498C16.5693 4.74376 15.4304 4.74376 14.4242 5.17498L7.47461 8.15336C6.98437 8.36346 6.6665 8.84552 6.6665 9.37889V16.3827C6.6665 18.9664 7.91423 21.3909 10.0166 22.8926L14.4499 26.0592C15.3771 26.7215 16.6226 26.7215 17.5498 26.0592L21.9831 22.8926C24.0854 21.3909 25.3332 18.9664 25.3332 16.3827V9.37889C25.3332 8.84552 25.0153 8.36347 24.5251 8.15336ZM20.7807 13.1247C21.1257 12.6934 21.0558 12.0641 20.6245 11.7191C20.1933 11.3741 19.564 11.444 19.219 11.8753L14.5836 17.6695L12.7069 15.7929C12.3164 15.4024 11.6833 15.4024 11.2927 15.7929C10.9022 16.1834 10.9022 16.8166 11.2927 17.2071L13.5644 19.4788C14.1966 20.1109 15.2379 20.0533 15.7964 19.3551L20.7807 13.1247Z",
    fill: "#263345"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChieldCheckFill);
export default __webpack_public_path__ + "static/media/Chield_check_fill.da8c1957.svg";
export { ForwardRef as ReactComponent };